<script>import { getCtx, getAttrs } from "../ctx.js";
import { srOnlyStyles } from "../../../internal/style.js";
const {
  states: { value }
} = getCtx();
function getValue(value2) {
  if (value2.length === 1) {
    return value2[0];
  } else {
    return value2[1] - value2[0];
  }
}
const attrs = {
  ...getAttrs("input"),
  style: srOnlyStyles
};
$:
  inputValue = getValue($value);
</script>

<input {...$$restProps} value={inputValue} {...attrs} />
